import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import GoogleMaps from '../../../partials/GoogleMaps'

const DeliveryPointModal = (props) => {
  const [show, setShow] = useState(false)
  const [item, setItem] = useState(false)

  const handleClose = () => {
    setShow(false)
    props.showSend(false)
  }

  useEffect(() => {
    setShow(props.show)
    setItem(props.item)
  }, [props])

  return (
    <>
      <Modal className={'right-modal'} show={show} onHide={handleClose}
             scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>Teslim Noktası Seçin</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ paddingRight: 15 }}>
          {
            item && (
              <>
                <div className={'row'}>
                  <div className={'col-12 mt-3'}>
                    <GoogleMaps
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDoCBowy-CymzJK8zDYm7-0eSFGlO5XWsw&libraries=places,geometry"
                      loadingElement={<div style={{ height: `100%` }}/>}
                      containerElement={<div style={{ height: 200 }}/>}
                      mapElement={<div style={{ height: `100%` }}/>}
                      markers={[item]}
                      defaultZoom={13}
                    />
                  </div>
                </div>

                <div className={'row mt-3'}>
                  <div className={'col-12'}>
                    <h5>{item.accountName}</h5>
                  </div>
                  <div className={'col-12'}>
                    <p>{item.addressLine}</p>
                  </div>
                  <div className={'col-12 d-none'}>
                    <h6>ÇALIŞMA SAATLERİ</h6>
                    <div className="row">
                      <div className="col-3">Hafta İçi</div>
                      <div className="col-9">09:00 - 19:00</div>
                      <div className="col-3">Cumartesi</div>
                      <div className="col-9">09:00 - 19:00</div>
                    </div>
                  </div>
                </div>

              </>
            )
          }
        </Modal.Body>
        <Modal.Footer className={'d-block'}>
          {
            item && (
              <div
                className={'col-12 d-flex align-items-center justify-content-center text-center'}>
                <a onClick={() => {
                    props.selectedPharmacySend(item.id)
                    handleClose();
                }}
                   className={'btn text-white btn-primary mt-3 mb-3 w-100'}>
                  Teslimat Noktasını Onaylayın
                </a>
              </div>
            )
          }

          <div className={'row'}>
            <div
              className={'col-12 d-flex align-items-center mt-2 justify-content-center text-center'}>
              <a onClick={handleClose}
                 className={'continue-shop-text text-body'}>
                Vazgeç
              </a>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default withRouter(DeliveryPointModal)


